import { axiosInstance as axios } from './axiosInstance';

/**
 * User service for handling user-related API calls
 */
const userService = {
  /**
   * Update user profile
   * @param {number|string} id User ID
   * @param {Object} userData User data to update (name, email, password, etc.)
   * @returns {Promise} Promise with updated user data
   */
  updateUser: async (id, userData) => {
    try {
      const response = await axios.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  },

  /**
   * Get current user details from backend
   * @returns {Promise} Promise with user data
   */
  getCurrentUser: async () => {
    try {
      const response = await axios.get('/auth/me');
      return response.data;
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  }
};

export default userService;
